import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=74c471c4&scoped=true"
import script from "./EditTask.vue?vue&type=script&lang=js"
export * from "./EditTask.vue?vue&type=script&lang=js"
import style0 from "./EditTask.vue?vue&type=style&index=0&id=74c471c4&prod&lang=scss&scoped=true"
import style1 from "./EditTask.vue?vue&type=style&index=1&id=74c471c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c471c4",
  null
  
)

export default component.exports